// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.expert-related_products-header {
  background: linear-gradient(90deg, #b4a362 39.94%, rgba(180, 163, 98, 0) 100%);
  border-radius: 4px;
}

#swiper_expert_related_products .swiper-wrapper {
  margin-top: 6px;
  width: 100%;
}
#swiper_expert_related_products .swiper-slide {
  width: calc(233 / var(--base-width) * 100vw);
}
#swiper_expert_related_products .swiper-slide .expert_related_products_avatar {
  height: auto;
}
#swiper_expert_related_products .swiper-slide .expert_related_products_avatar img {
  max-width: unset;
}
#swiper_expert_related_products .swiper-slide .image-container {
  width: calc(82 * var(--width-ratio));
  height: calc(82 * var(--width-ratio));
  padding: calc(10 * var(--width-ratio));
}
#swiper_expert_related_products .swiper-slide .myImage {
  width: 100%;
  height: 100%;
  background-position: center !important;
  background-size: cover !important;
  background-image: url("/assets/img/default/ec_commodity_default.png");
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  border-bottom-right-radius: 10px;
  border-bottom-left-radius: 10px;
}
#swiper_expert_related_products .swiper-slide .flex {
  display: flex;
  flex-direction: column;
}
#swiper_expert_related_products .swiper-slide .flex1 {
  align-items: center;
  justify-content: center;
  display: flex;
}
#swiper_expert_related_products .swiper-slide .flex2 {
  align-items: center;
  justify-content: center;
  display: flex;
  width: calc(120 / var(--base-width) * 100vw);
  height: calc(44 * var(--width-ratio));
  margin: auto;
  margin-top: 4px;
}
#swiper_expert_related_products .swiper-slide .expert-related-products-product-div {
  background: white;
  border-radius: 20px;
  margin-top: -10px;
  margin-left: calc(7 * var(--width-ratio));
}
#swiper_expert_related_products .swiper-slide .expert-related-products-product-title-div {
  padding-top: 10px;
  padding-right: 10px;
}
#swiper_expert_related_products .swiper-slide .ori-price {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 500;
  font-size: calc(13 * var(--width-ratio));
  line-height: calc(22 * var(--width-ratio));
  text-decoration-line: line-through;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/expert-related-product/expert-related-product.component.scss"],"names":[],"mappings":"AAAA;EACE,8EAAA;EAKA,kBAAA;AAHF;;AAOE;EACE,eAAA;EAEA,WAAA;AALJ;AAQE;EACE,4CAAA;AANJ;AAQI;EACE,YAAA;AANN;AAOM;EACE,gBAAA;AALR;AASI;EACE,oCAAA;EACA,qCAAA;EACA,sCAAA;AAPN;AAUI;EACE,WAAA;EACA,YAAA;EACA,sCAAA;EACA,iCAAA;EACA,qEAAA;EAEA,4BAAA;EACA,6BAAA;EACA,gCAAA;EACA,+BAAA;AATN;AAYI;EACE,aAAA;EACA,sBAAA;AAVN;AAaI;EACE,mBAAA;EACA,uBAAA;EACA,aAAA;AAXN;AAcI;EACE,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,4CAAA;EACA,qCAAA;EACA,YAAA;EACA,eAAA;AAZN;AAeI;EACE,iBAAA;EACA,mBAAA;EAEA,iBAAA;EACA,yCAAA;AAdN;AAiBI;EACE,iBAAA;EACA,mBAAA;AAfN;AAkBI;EACE,qBAAA;EACA,kBAAA;EACA,gBAAA;EACA,wCAAA;EACA,0CAAA;EACA,kCAAA;AAhBN","sourcesContent":[".expert-related_products-header {\n  background: linear-gradient(\n    90deg,\n    #b4a362 39.94%,\n    rgba(180, 163, 98, 0) 100%\n  );\n  border-radius: 4px;\n}\n\n#swiper_expert_related_products {\n  .swiper-wrapper {\n    margin-top: 6px;\n    // padding-left: 26px;\n    width: 100%;\n  }\n\n  .swiper-slide {\n    width: calc(233 / var(--base-width) * 100vw);\n\n    .expert_related_products_avatar {\n      height: auto;\n      img {\n        max-width: unset;\n      }\n    }\n\n    .image-container {\n      width: calc(82 * var(--width-ratio));\n      height: calc(82 * var(--width-ratio));\n      padding: calc(10 * var(--width-ratio));\n    }\n\n    .myImage {\n      width: 100%;\n      height: 100%;\n      background-position: center !important;\n      background-size: cover !important;\n      background-image: url(\"/assets/img/default/ec_commodity_default.png\");\n\n      border-top-left-radius: 20px;\n      border-top-right-radius: 20px;\n      border-bottom-right-radius: 10px;\n      border-bottom-left-radius: 10px;\n    }\n\n    .flex {\n      display: flex;\n      flex-direction: column;\n    }\n\n    .flex1 {\n      align-items: center;\n      justify-content: center;\n      display: flex;\n    }\n\n    .flex2 {\n      align-items: center;\n      justify-content: center;\n      display: flex;\n      width: calc(120 / var(--base-width) * 100vw);\n      height: calc(44 * var(--width-ratio));\n      margin: auto;\n      margin-top: 4px;\n    }\n\n    .expert-related-products-product-div {\n      background: white;\n      border-radius: 20px;\n      // margin-top: calc(-10 * var(--width-ratio));\n      margin-top: -10px;\n      margin-left: calc(7 * var(--width-ratio));\n    }\n\n    .expert-related-products-product-title-div {\n      padding-top: 10px;\n      padding-right: 10px;\n    }\n\n    .ori-price {\n      font-family: \"Roboto\";\n      font-style: normal;\n      font-weight: 500;\n      font-size: calc(13 * var(--width-ratio));\n      line-height: calc(22 * var(--width-ratio));\n      text-decoration-line: line-through;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
